import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinrahatani() {



const cardData = {
  keyword: " Cab Service in Rahatani  ",

"headingDescription": "SRS Cab Service offers Cab Service in Rahatani, providing smooth, reliable, and comfortable travel solutions for residents, professionals, and families. Whether you need daily commuting, airport transfers, office travel, or outstation cab services, our well-maintained vehicles and skilled drivers ensure a safe and timely journey. With quick booking, transparent pricing, and 24/7 support, SRS Cab Service makes traveling in Rahatani convenient, efficient, and completely hassle-free.",
"topPlaces": [
  {
    "title": "Rahatani Lake",
    "description": "Rahatani Lake is a peaceful spot ideal for relaxation and evening walks. Travelers using Cab Service in Rahatani from SRS Cab Service often visit for calm surroundings and scenic views."
  },
  {
    "title": "Pimple Saudagar Garden",
    "description": "Pimple Saudagar Garden is a well-known green space nearby, perfect for family outings and leisure time. Visitors using SRS Cab Service often include it in their daily plans."
  },
  {
    "title": "Spot 18 Mall",
    "description": "Spot 18 Mall is a popular destination for shopping, dining, and entertainment. Travelers using SRS Cab Service often visit for movies and leisure activities."
  },
  {
    "title": "Balewadi High Street",
    "description": "Balewadi High Street is a vibrant hub for restaurants, cafes, and nightlife. Visitors using SRS Cab Service often explore this area for social outings."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "Rajiv Gandhi Infotech Park is a major IT hub located near Rahatani. Business travelers using SRS Cab Service frequently commute here for work."
  },
  {
    "title": "Aundh",
    "description": "Aundh is a nearby upscale locality known for shopping malls and lifestyle destinations. Travelers using SRS Cab Service often visit for dining and shopping."
  },
  {
    "title": "Baner Hills",
    "description": "Baner Hills is a popular spot for trekking and scenic views. Visitors using SRS Cab Service often go here for outdoor activities and relaxation."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "This science park is an educational and fun destination for families. Travelers using SRS Cab Service often include it in their outings."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and activities. Visitors using SRS Cab Service often travel here for matches and fitness events."
  },
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is a famous religious site. Travelers using SRS Cab Service often visit to seek blessings and spiritual experiences."
  }
],



services: [
{
name: "Rahatani Cab Service",
description: "Rahatani cab service offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Rahatani",
description: "Taxi service in Rahatani provides convenient travel for local and intercity routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Rahatani Taxi Service",
description: "Rahatani taxi service offers dependable transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Rahatani",
description: "Cab booking Rahatani provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Rahatani",
description: "Taxi booking Rahatani offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Rahatani",
description: "Cab near Rahatani helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Rahatani",
description: "Taxi near Rahatani offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Rahatani",
description: "Best cab service in Rahatani provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Rahatani",
description: "Cheap cab service Rahatani offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Rahatani",
description: "Affordable cab service Rahatani provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Rahatani Cab Hire",
description: "Rahatani cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Rahatani Taxi Hire",
description: "Rahatani taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Rahatani Cab for Airport",
description: "Rahatani cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Rahatani Airport Cab Service",
description: "Rahatani airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Rahatani Cab for Outstation",
description: "Rahatani cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Rahatani Pune",
description: "Cab service Rahatani Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Rahatani Pune",
description: "Taxi service Rahatani Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Rahatani Pune",
description: "Cab booking Rahatani Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab on Rent in Rahatani",
description: "Innova cab on rent in Rahatani offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab on Rent in Rahatani",
description: "Innova Crysta cab on rent in Rahatani provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab on Rent Rahatani",
description: "Ertiga cab on rent Rahatani offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab on Rent in Rahatani",
description: "Dzire cab on rent in Rahatani provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab on Rent in Rahatani",
description: "Sedan cab on rent in Rahatani offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab on Rent Rahatani",
description: "Luxury cab on rent Rahatani provides premium travel experience for corporate and special trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller on Rent in Rahatani",
description: "Tempo traveller on rent in Rahatani offers group travel solutions for family and corporate trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent in Rahatani",
description: "Urbania on rent in Rahatani provides luxury group travel for large families and corporate trips. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Best Cab Service in Rahatani for Airport Drop",
description: "Best cab service in Rahatani for airport drop offers reliable transfer for passengers. Customers can book cabs for timely airport travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Affordable Cab Service Rahatani for Outstation",
description: "Affordable cab service Rahatani for outstation provides cost-effective travel solutions. Customers can book cabs for long-distance journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Rahatani Cab Service for Family Trip",
description: "Rahatani cab service for family trip offers comfortable travel for vacations and outings. Customers can book spacious vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with family trip cab services."
}
],

tableData: [
["Rahatani Cab Service","Taxi Service in Rahatani"],
["Rahatani Taxi Service","Cab Booking Rahatani"],
["Taxi Booking Rahatani","Cab Near Rahatani"],
["Taxi Near Rahatani","Best Cab Service in Rahatani"],
["Cheap Cab Service Rahatani","Affordable Cab Service Rahatani"],
["Rahatani Cab Hire","Rahatani Taxi Hire"],
["Rahatani Cab for Airport","Rahatani Airport Cab Service"],
["Rahatani Cab for Outstation","Cab Service Rahatani Pune"],
["Taxi Service Rahatani Pune","Cab Booking Rahatani Pune"],
["Innova Cab on Rent in Rahatani","Innova Crysta Cab on Rent in Rahatani"],
["Ertiga Cab on Rent Rahatani","Dzire Cab on Rent in Rahatani"],
["Sedan Cab on Rent in Rahatani","Luxury Cab on Rent Rahatani"],
["Tempo Traveller on Rent in Rahatani","Urbania on Rent in Rahatani"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Rahatani Pune",
    WhyChoosedescription: "SRS Cab Service offers dependable cab service in Rahatani Pune for daily travel, office commutes, airport transfers, and outstation trips with professional drivers and smooth booking experience."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly cab service in Rahatani with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab & Taxi Availability",
    WhyChoosedescription: "Our Rahatani cab service operates 24/7, making it easy to book rides anytime for early morning travel, late-night pickups, and emergency trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from sedan cars like Dzire, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for all travel needs."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are clean, air-conditioned, and regularly serviced to ensure maximum comfort and safety during your journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Rahatani Area",
    WhyChoosedescription: "We provide quick pickup from homes, societies, offices, and nearby areas like Pimple Saudagar, Wakad, Pimpri, and Kalewadi."
  },
  {
    WhyChooseheading: "Best for Airport & Outstation Travel",
    WhyChoosedescription: "Our Rahatani cab service is ideal for Pune Airport transfers, Mumbai travel, family trips, and long-distance outstation journeys."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Rahatani Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by customers for punctual service, professional drivers, and reliable travel experience across Pune."
  }
]
}

const faqData = [
  { 
    question: "Do you provide cab service in Rahatani Pune?", 
    answer: "Yes, SRS Cab Service offers reliable cab service in Rahatani Pune for local travel, airport transfers, and outstation trips. Our services are suitable for individuals, families, and corporate bookings." 
  },
  { 
    question: "Is cab service available 24 hours in Rahatani?", 
    answer: "Yes, our cab service in Rahatani operates 24/7. You can book a cab anytime for early morning rides, late-night travel, or urgent bookings." 
  },
  { 
    question: "Do you provide airport cab service from Rahatani?", 
    answer: "Yes, we provide Pune Airport pickup and drop services from Rahatani with on-time arrival and professional drivers to ensure stress-free travel." 
  },
  { 
    question: "Which areas do you cover near Rahatani?", 
    answer: "We cover Pimple Saudagar, Wakad, Pimpri, Kalewadi, and nearby areas. Our cab service is available across Pune and PCMC regions." 
  },
  { 
    question: "Which vehicles are available in Rahatani cab service?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for different travel needs." 
  },
  { 
    question: "Can I book cab online in Rahatani Pune?", 
    answer: "Yes, you can easily book cab service in Rahatani online or via phone with instant confirmation and easy booking process." 
  },
  { 
    question: "Do you provide outstation cab service from Rahatani?", 
    answer: "Yes, we provide outstation cab services from Rahatani to Mumbai, Nashik, Shirdi, Goa, and other major destinations." 
  },
  { 
    question: "Is cab service suitable for family trips?", 
    answer: "Yes, we provide spacious and comfortable vehicles like Ertiga, Innova, and Tempo Travellers which are perfect for family and group travel." 
  },
  { 
    question: "Are cab fares affordable in Rahatani?", 
    answer: "Yes, we offer affordable cab service in Rahatani with transparent pricing and no hidden charges." 
  },
  { 
    question: "Are vehicles clean and drivers professional?", 
    answer: "Yes, all vehicles are regularly cleaned and sanitized, and our drivers are trained, experienced, and verified for safe travel." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked cab from Rahatani to Pune Airport. The driver was punctual and the car was clean. Overall experience was very smooth and comfortable. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Rahatani Pune. I booked for Mumbai travel and the journey was very comfortable. Driver was professional and pricing was also reasonable.",
    rating: 5
  }
];




















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Rahatani Cab Service",
  "description": "Reliable cab service in Rahatani, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Innova Crysta, Ertiga, sedan, and SUV cab options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rahatani",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411017",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5990",
    "longitude": "73.7920"
  },
  "url": "https://www.srscabservice.com/rahatani-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Rahatani, Pune"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Cab Service in Rahatani | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Rahatani, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Innova Crysta, Ertiga, sedan, and SUV cab options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinrahatani;